import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { Row, Col, Card } from 'react-bootstrap';

const CardIngresos = ({ data }) => {
    const [its, setits] = useState({ me: 0, mi: 0, di: 0, de: 0 });
    useEffect(() => {
        getPagos();
    }, [data]);

    const getPagos = async () => {
        const today = moment().format('YYYY-MM-DD');

       let currentMonthData = data.filter((item) => {
            const fecha = moment(item.fecha);
            return fecha.isSame(today, 'month') && (item.tipo === 'INGRESO' || item.tipo === 'EGRESO');
        });

        // Filtrar por el día de hoy y tipo 'INGRESO' o 'EGRESO'
        let todayData = data.filter((item) => {
            const fecha = moment(item.fecha);
            return fecha.isSame(today, 'day') && (item.tipo === 'INGRESO' || item.tipo === 'EGRESO');
        });

        // Calcular el total del mes y del día de hoy para 'INGRESO' y 'EGRESO'
        const totalMonthIngreso = currentMonthData.reduce((acc, curr) => {
            return curr.tipo === 'INGRESO' ? acc + curr.monto : acc;
        }, 0);

        const totalTodayIngreso = todayData.reduce((acc, curr) => {
            return curr.tipo === 'INGRESO' ? acc + curr.monto : acc;
        }, 0);

        const totalMonthEgreso = currentMonthData.reduce((acc, curr) => {
            return curr.tipo === 'EGRESO' ? acc + curr.monto : acc;
        }, 0);

        const totalTodayEgreso = todayData.reduce((acc, curr) => {
            return curr.tipo === 'EGRESO' ? acc + curr.monto : acc;
        }, 0);

        setits({
            me: totalMonthEgreso.toLocaleString('es-MX', {
                style: 'currency',
                currency: 'MXN',
            }),
            mi: totalMonthIngreso.toLocaleString('es-MX', {
                style: 'currency',
                currency: 'MXN',
            }),
            di: totalTodayIngreso.toLocaleString('es-MX', {
                style: 'currency',
                currency: 'MXN',
            }),
            de: totalTodayEgreso.toLocaleString('es-MX', {
                style: 'currency',
                currency: 'MXN',
            }),
        });
    };
    return (
        <Row>
            <Col xs={12}>
                <Card className="widget-inline">
                    <Card.Body className="p-0">
                        <Row className="g-0">
                            <Col sm={4} lg={3}>
                                <Card className="shadow-none m-0">
                                    <Card.Body className="text-center">
                                        <h3>
                                            <span>{its.di}</span>
                                        </h3>
                                        <p className="text-muted font-15 mb-0">Total Ingresos Hoy</p>
                                    </Card.Body>
                                </Card>
                            </Col>

                            <Col sm={6} lg={3}>
                                <Card className="shadow-none m-0 border-start">
                                    <Card.Body className="text-center">
                                        <h3>
                                            <span>{its.mi}</span>
                                        </h3>
                                        <p className="text-muted font-15 mb-0">Total Ingresos</p>
                                    </Card.Body>
                                </Card>
                            </Col>

                            <Col sm={6} lg={3}>
                                <Card className="shadow-none m-0 border-start">
                                    <Card.Body className="text-center">
                                        <h3>
                                            <span>{its.me}</span>
                                        </h3>
                                        <p className="text-muted font-15 mb-0">Total de egresos</p>
                                    </Card.Body>
                                </Card>
                            </Col>

                            <Col sm={6} lg={3}>
                                <Card className="shadow-none m-0 border-start">
                                    <Card.Body className="text-center">
                                        <h3>
                                            <span>{its.de}</span>
                                        </h3>
                                        <p className="text-muted font-15 mb-0">Total de egresos hoy</p>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>
            </Col>
        </Row>
    );
};

export default CardIngresos;
